const colors = {
  black: "#1D1E2C",
  blue: "#008dd5",
  darkBlue: "#00053A",
};

export default colors;
